import TravelPreferencesCardContainer from './travel-preferences-card-container';

export default TravelPreferencesCardContainer;
